import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts';

const OrderDetailPage = lazy(() => import('./Order.page'));

export const OrderDetail = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <OrderDetailPage />
      </Suspense>
    </KDErrorBoundary>
  );
};
